import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import AudioSection from "@/components/site/AudioSection";
import CustomSection from "@/components/site/CustomSection";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import QuoteSection from "@/components/site/QuoteSection";
import Footer from "@/components/site/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -64, duration: 1.4 });
    }
  };

  return (
    <div className="bg-[#0A0B0E] text-white min-h-screen">
      <Nav scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <Marquee />
        <AudioSection />
        <CustomSection />
        <About />
        <Process />
        <Testimonials />
        <QuoteSection />
      </main>
      <Footer scrollTo={scrollTo} />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
